import { render } from "./TeamGameDayView.vue?vue&type=template&id=c31d7f00"
import script from "./TeamGameDayView.vue?vue&type=script&lang=js"
export * from "./TeamGameDayView.vue?vue&type=script&lang=js"

import "./TeamGameDayView.vue?vue&type=style&index=0&id=c31d7f00&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__